export const KeywordListColumns = [
  {
    title: "关键字",
    width: 880,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "value",
    key: "value"
  },
  {
    title: "创建者",
    width: 140,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "creator",
    key: "creator"
  },
  {
    title: "创建日期",
    width: 180,
    ellipsis: true,
    align: "center",
    resizable: true,
    scopedSlots: { customRender: "insertTime" },
    key: "insertTime"
  },
  {
    title: "修改日期",
    width: 180,
    ellipsis: true,
    align: "center",
    resizable: true,
    scopedSlots: { customRender: "updateTime" },
    key: "updateTime"
  },
  {
    title: "操作",
    fixed: "right",
    align: "center",
    width: 88,
    className: "erp-table-operation-col",
    key: "operation",
    scopedSlots: { customRender: "operation" }
  }
]
